import { ActivityIcon } from "./activity";
import { AppStoreButton } from "./app-store-button";
import { AppleIcon } from "./apple";
import { BankIcon } from "./bank";
import { CalenderIcon } from "./calender";
import { ChatHelpIcon } from "./chat-help";
import { CheckmarkBadgeIcon } from "./checkmark-badge";
import { ChevronLeftIcon } from "./chevron-left";
import { CircleCloseIcon } from "./circle-close";
import { ClockIcon } from "./clock";
import { ContactIcon } from "./contact";
import { CopyIcon } from "./copy";
import { DefaultAvatarIcon } from "./default-avatar";
import { DismissCircleIcon } from "./dismiss-circle";
import { DismissCircleFilledIcon } from "./dismiss-circle-filled";
import { DocumentUploadIcon } from "./document-upload";
import { EyeIcon } from "./eye";
import { FacebookIcon } from "./facebook";
import { GoogleIcon } from "./google";
import { GooglePlayButton } from "./google-play-button";
import { HelpCircleIcon } from "./help-circle";
import { HomeCheckmarkIcon } from "./home-checkmark";
import { InfoCircleIcon } from "./info-circle";
import { InfoWarningIcon } from "./info-warning";
import { LoaderIcon } from "./loader";
import { MailInboxIcon } from "./mail-inbox";
import { PhoneIcon } from "./phone";
import { PropertyBadgeIcon } from "./property-badge";
import { InfoIcon } from "./property-details/info";
import { TickCircleIcon } from "./tick-circle";
import { UploadIcon } from "./upload";

export {
  EyeIcon,
  CalenderIcon,
  InfoWarningIcon,
  GoogleIcon,
  AppleIcon,
  FacebookIcon,
  DefaultAvatarIcon,
  LoaderIcon,
  UploadIcon,
  MailInboxIcon,
  PhoneIcon,
  AppStoreButton,
  GooglePlayButton,
  ChevronLeftIcon,
  ChatHelpIcon,
  DismissCircleIcon,
  PropertyBadgeIcon,
  InfoIcon,
  CheckmarkBadgeIcon,
  CopyIcon,
  TickCircleIcon,
  DocumentUploadIcon,
  InfoCircleIcon,
  CircleCloseIcon,
  DismissCircleFilledIcon,
  ClockIcon,
  ActivityIcon,
  HomeCheckmarkIcon,
  BankIcon,
  ContactIcon,
  HelpCircleIcon,
};
